// extracted by mini-css-extract-plugin
export default {"orderIcon":"item-table_orderIcon__+kG6z","cell":"item-table_cell__Ib+G8","imgCell":"item-table_imgCell__xok+r","row":"item-table_row__aqGt3","image":"item-table_image__lei2Z"};